import {  memo } from "react";
import Card from "@mui/material/Card";
import "./DashboardCard.css";
import CountUp from "react-countup";
import styled from "@emotion/styled";

const Count = styled.div`
  font-size: 3rem;
  font-weight: bold;
  color: #6860ee;
`;

const CardTitle = styled.span`
  color: var(--header__color);
`;

const CardMoreSpan = styled.p`
  color: var(--header__color);
`;
const formatNumber = (value) => {
  if (value === null || value === undefined) {
    return "0";
  }
  const numValue = Number(value);
  if (isNaN(numValue)) {
    return "0";
  }
  if (numValue >= 1000) {
    return (numValue / 1000).toFixed(2) + "K";
  }
  return numValue.toString();
};

const DashboardCard = ({
  title,
  value,
  trend,
  headerIcon,
  iconBgClass,
  cardBackgroundImage,
  animate = true,
}) => {
  const cardStyle = {
    boxShadow: "none",
    backgroundImage: `url(${cardBackgroundImage})`,
    backgroundSize: "25%",
    backgroundPosition: "right bottom",
    backgroundRepeat: "no-repeat",
    backgroundColor: "var(--card__background)",
    color: "var(--header__color)",
    border: "1px solid var(--card__border)",
    borderRadius: "20px",
  };

  const safeValue = value === null || value === undefined ? 0 : Number(value);
  return (
    <Card style={cardStyle}>
      <div className="metric-card">
        <div className="card-header">
          <div className="header-icon-container">
            <CardTitle className="title">{title}</CardTitle>
            <div className={`icon-wrapper ${iconBgClass}`}>
              <img alt="" src={headerIcon} className="card-header-icon" />
            </div>
          </div>
        </div>
        <div className="metric-value">
          <Count>
            {animate ? (
              <CountUp
                start={0}
                end={safeValue}
                duration={5}
                separator=","
                formattingFn={formatNumber}
              />
            ) : (
              formatNumber(safeValue)
            )}
          </Count>
        </div>
        <div className="metric-value-description">
          <CardMoreSpan className="trend-text">{trend}</CardMoreSpan>
        </div>
      </div>
    </Card>
  );
};

export default memo(DashboardCard);